(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('RootCauseAnalysis', RootCauseAnalysis);

    RootCauseAnalysis.$inject = ['$resource', 'DateUtils'];

    function RootCauseAnalysis ($resource, DateUtils) {
        var resourceUrl =  'api/root-cause-analyses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
